import React from 'react';
import Paper from '@material-ui/core/Paper';
import { t } from 'ttag';
import DataTable from '../../../components/DataTable';
import { BASE_STATUS_TITLES } from '../../../utils/enums';
import useApi from '../../../api';
import useDataList from '../../../hooks/useDataList';
import { insertAt } from '../../../utils/helpers';
import useUser from '../../../auth/hooks';

const ListView = () => {
  const { user } = useUser();
  const api = useApi();
  const { data, loading, onEdit, onAdd, onDelete } = useDataList({
    schema: api.schema.gyms,
    router: api.router.gyms,
  });

  const columns = [
    { title: t`Id`, field: 'id', editable: 'never' },
    { title: t`Назва`, field: 'name' },
    { title: t`Адреса`, field: 'address' },
    { title: t`Телефон`, field: 'phone' },
    { title: t`Email`, field: 'email' },
    { title: t`Адміністратор`, field: 'administrator' },
    {
      title: t`Статус`,
      field: 'status',
      render: ({ status }) => BASE_STATUS_TITLES[status],
    },
  ];
  const adminColumns = [
    { title: t`Клуб`, field: 'club', render: ({ club }) => club.shortName },
  ];
  user.isAdmin && insertAt(columns, 1, ...adminColumns);

  return (
    <Paper>
      <DataTable
        isLoading={loading}
        title={t`Список залів`}
        columns={columns}
        data={data || []}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Paper>
  );
};

export default ListView;
